var app = angular.module("leonardo");

var AdminClientInstanceFiltersController = function(
  $scope,
  $controller
) {

  $controller('FiltersBaseController', { $scope: $scope });

  $scope.filters_options = [
    {
      id: 'search',
      name: 'Client Instance Name',
      label: null,
      inline: false,
      type: 'text',
      placeholder: 'Client Instance name',
      condition: true,
      conflicts: [],
      onSubmit: $scope.filter
    }
  ];
};

app.controller('AdminClientInstanceFiltersController', [
  '$scope',
  '$controller',
  AdminClientInstanceFiltersController
]);
